import React from "react";
import { OrderUseContext } from "../../context/AdminDashboard/OrderContext";
import { HeaderOrderList } from "../../data/TablesHeader";
import loading from "../../photos/Spinner-1.9s-137px.gif";
import SearchHeader from "../../components/main/SearchHeader";
import Table from "../../components/main/Table";
import Pagination from "../main/Pagination";
import DeleteModal from "../atoms/DeleteModal";
import EditeOrderModal from "./EditeOrderModal";
const OrderList = () => {
  const {
    orderList,
    onedite,
    ondeleteorder,
    tableorderloaded,
    
    changePage,
    pageNumber,
    getorderText,
    buttonordersearch,
    showDeleteModal,
    closeDeleteModal,
    RemoveItem,
    name,
    doneEditorder,
    changestatus,
    onchangeInput,
    showModal,
    closeModal,
    modaldata,
    codeval,
    disable,
    countallorder
  } = OrderUseContext();
  return (
    <div>
      <div
        className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
        dir="rtl">
        <SearchHeader
          title=" فهرست سفارش‌ها"
          number={countallorder}
          nobtn={true}
          placeholder="جست و جو: شماره تماس، نام"
          buttonSearch={buttonordersearch}
          gettext={getorderText}
          // onClick={AddClient}
          borderBlue="border-blue border-1"
        />
        {tableorderloaded ? (
          <div className="flex justify-center items-center w-24 h-203 m-auto bg-transparent">
            <img src={loading} alt="" />
          </div>
        ) : (
          <>
            <Table
              thData={HeaderOrderList}
              tableData={orderList}
              Hempty={"h-203"}
              emptyText={"سفارشی یافت نشد."}
              thwidth={"w-15"}
              onediteO={onedite}
              onDeleteR={ondeleteorder}
              detailKey={"id"}
              deletetext={"حذف سفارش"}
              detailtext={"جزئیات سفارش"}
              detailTo={"/order/log"}
              edittext={"ویرایش سفارش"}
            />
            <Pagination
              changePage={changePage}
              countAll={countallorder}
              currentPage={pageNumber}
            />
          </>
        )}
        <DeleteModal
          text={`آیا برای حذف ${name}  مطمئن هستید؟`}
          showDeleteModal={showDeleteModal}
          closeDeleteModal={closeDeleteModal}
          RemoveItem={RemoveItem}
          title="اخطار حذف سفارش"
        />
        <EditeOrderModal
          showModal={showModal}
          closeModal={closeModal}
          modaldata={modaldata}
          codeval={codeval}
          onchangeInput={onchangeInput}
          onchangeselect={changestatus}
          doneEdit={doneEditorder}
          disabled={disable}
        />
      </div>
    </div>
  );
};

export default OrderList;
